/* eslint-disable */
import { atom } from "jotai";

export const phoneNumberJotai = atom("");

const authState = atom({ access_token: "", refresh_token: "", auth0Id: "" });

export default authState;
